import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-me",
  "use": "icon-me-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-me\"><path fill=\"#333333\" d=\"M0 868.352h582.656V1024H0V868.352m0-578.56h1024v155.648H0V289.792zM0 0h1024v155.648H0V0z m0 579.584h1024v155.648H0V579.584z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol